import { PrismicPageParser } from "../../shared/utils/prismicPageParser"

const AnthologyContainer = () => {
  const data = JSON.parse(window.prismic_data)
  const pageId = window.pageId

  return (
    <section id="mm-anthology" className="pageContainer" aria-label="Anthology page">
      <PrismicPageParser pageData={data} pageId={pageId} />
    </section>
  )
}

export default AnthologyContainer
